export const ALL_MODES_PATH = '/';
export const LEGACY_ALL_MODES_PATH = '/all-modes';

export const isAllModesPath = (pathname = '') =>
  pathname === ALL_MODES_PATH ||
  pathname === LEGACY_ALL_MODES_PATH ||
  pathname.startsWith(`${LEGACY_ALL_MODES_PATH}/`);

export const isInteractionMode = (
  value: string | null | undefined
): value is 'desktop_companion' | 'smart_assistant' | 'immersive' =>
  value === 'desktop_companion' || value === 'smart_assistant' || value === 'immersive';

export const getStoredInteractionMode = () => {
  if (typeof window === 'undefined') return null;
  const value = window.localStorage.getItem('interaction_mode');
  // 互动课堂已拆分到独立项目并从代码中移除:localStorage 残留的课堂值不再是合法模式,
  // isInteractionMode 会将其判为 false 而回退到 null。
  return isInteractionMode(value) ? value : null;
};

export const getRouteInteractionMode = (pathname = '') => {
  if (!isAllModesPath(pathname)) return 'smart_assistant' as const;
  return getStoredInteractionMode() || ('desktop_companion' as const);
};
